// extracted by mini-css-extract-plugin
export default {"card":"Card_card__LLIlc","image":"Card_image__yI-Xz","buttons":"Card_buttons__z3Mxi","buttonSecondary":"Card_buttonSecondary__P4LCY","icon":"Card_icon__6v1uQ"};